var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCutting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98913 6.00169C5.09201 6.00169 5.98607 5.10763 5.98607 4.00475C5.98607 2.90187 5.09201 2.00781 3.98913 2.00781C2.88625 2.00781 1.99219 2.90187 1.99219 4.00475C1.99219 5.10763 2.88625 6.00169 3.98913 6.00169Z",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 5.40625L7.98115 7.98896",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3063 2.66406L5.39844 10.5719",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98913 13.9861C5.09201 13.9861 5.98607 13.092 5.98607 11.9891C5.98607 10.8862 5.09201 9.99219 3.98913 9.99219C2.88625 9.99219 1.99219 10.8862 1.99219 11.9891C1.99219 13.092 2.88625 13.9861 3.98913 13.9861Z",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85156 9.85156L13.3129 13.3129",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutting);
export default __webpack_public_path__ + "static/media/cutting.81f566c9502a699baabb21b75bf14c3e.svg";
export { ForwardRef as ReactComponent };